import { useQueryClient } from "@tanstack/react-query"
import React, { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router"

import { BindOrderUpload, GetUploadedFilesByModule, GetUploadedFilesByModuleV2 } from "../../../services/queries.js"
import Dropdown from "../../Common/Form/DropdownWithSetValueSupport"
import Loader from "../../Common/Loader/loader.js"
import ReactTable from "../../Common/ReactTable/index.js"
import ServiceCenterFilter from "../../ServiceCenterFilter/index.js"
import FileUploderWithDragandDrop from "./uploader"

const Uploader = ({ uploadedData,
    uploadPermissionDetails ={},
    onHandleUpload,
    handleRemoveSaveData,
    count,
    formats,
    uploaderLabel,
    filesSupportLabel,
    module,
    isOlderUpload,
    isCustomStyling,
    setIsUploadClicked,
    customFileName,
    sendFileAsBinary,
    uploaderWrapperClass,
    useNewApiforUpload,
    orderManagementUpload,
    bulkTicketID,
    disabled,
    serviceCenterFeature,
    serviceCenterListData,
    serviceCenterHandler,
    serviceCenterDefaultValue,
    uploadedFileName,
    serviceCenterId,
    customerNumber
}) => {
    const { t } = useTranslation()
    const queryClient = useQueryClient()
    const navigate = useNavigate()
    const [viewselected, setViewSelected] = useState("10")
    const [bindedOrderUploadList, setBindedOrderUploadList] = useState([])
    const { data: fileDetails, status: fileDetailsStatus, refetch: retriggerList } = useNewApiforUpload ?
        GetUploadedFilesByModuleV2(module, viewselected,serviceCenterId) :GetUploadedFilesByModule(module, viewselected,customerNumber)

    const { data: bindOrderUpload, status: bindOrderUploadStatus } = BindOrderUpload()

    
    const onHandleViewChange = (e) => {
        const { value } = e
        setViewSelected(value)
    }
    const column = [
        {
            Header: t("common.uploaderFileName"),
            //accessor: "file_name"
            accessor: (row) => (
                <div className="w-36 h-5 truncate block">
                    <span title={ row?.file_name }>{ row?.file_name }</span>
                </div>
            )
        },
        {
            Header: t("common.uploaderErrorFileName"),
            accessor: "error_url",
            Cell: ({ value }) => ( value  ? <a target="_blanck" href={ `${value}` } 
                className="text-primary-100 text-sm font-lighter underline"
                rel="noreferrer">
                { t("common.uploaderErrorlabel") }
            </a> : "")
        },
        {
            Header: t("common.uploaderLastUpdatedBy"),
            accessor: "updated_by_name",
            type: "updatedBy"
        },
        {
            Header: orderManagementUpload? t("reviewOrder.upload.fileStatus") : t("common.uploaderStatusLabel"),
            accessor: "status",
            Cell: ({ value }) => ( 
                <div className={ `flex justify-center 
                    items-center gap-[10px] flex-[1_0_0] w-146 h-30
                    rounded-md ${value?.toLowerCase() === "in process" ? "bg-greenyellow" :
                    value?.toLowerCase() === "completed" ? "bg-greenlight" : 
                        value?.toLowerCase() === "rejected" ? "bg-lightred" : 
                            value?.toLowerCase() === "partially completed" ? "bg-lighterBlue" :"bg-lightred" 
                }` }>
                    <span className="text-xs font-lighter uppercase text-secondary-50">
                        { statusHelper(value) }
                    </span>
                </div>
            )        
        }
    ]

    const statusHelper =(value)=>{
        const status = value?.toLowerCase()
        if(status === "in process"){
            return t("status.inProcess")
        } else if (status === "completed"){
            return t("status.completed")
        } else if(status === "rejected") {
            return t("status.rejected")
        } else if(status === "partially completed"){
            return t("status.partiallyCompleted")
        } else if(status === "error") {
            return t("status.error")
        } else {
            return value
        }

    }
    if (orderManagementUpload) {
        const orderIdColumn = {
            Header: t("orderManagement.orderID"),
            accessor: "order_id"
        }
        column.splice(2, 0, orderIdColumn)
        const orderStatusColumn = {
            Header: t("reviewOrder.upload.orderStatus"),
            accessor: "order_status",
            Cell: ({ value }) => ( 
                <div className={ `flex justify-center 
                    items-center gap-[10px] flex-[1_0_0] w-146 h-30
                    rounded-md ${value?.toLowerCase() === "in process" ? "bg-greenyellow" :
                    value?.toLowerCase() === "completed" ? "bg-greenlight" : 
                        value?.toLowerCase() === "rejected" ? "bg-lightred" : 
                            value?.toLowerCase() === "partially completed" ? "bg-lighterBlue" :"" 
                }` }>
                    <span className="text-xs font-lighter uppercase text-secondary-50">
                        { statusHelper(value) }
                    </span>
                </div>
            ) 
        }
        column.splice(4, 0, orderStatusColumn)
    }
    
    useEffect(() => {
        let refershlist
        clearInterval(refershlist)
        refershlist = setInterval(() => {
            retriggerList()
        }, 60000)
        return (() => {
            clearInterval(refershlist)
        })
    }, [])

    const file =  fileDetails?.data?.filter(row=> row.file_name === uploadedFileName)
    useEffect(()=>{
        if(orderManagementUpload && fileDetailsStatus === "success"){
            if(file)
            {
                if(file[0]?.status === "COMPLETED")
                {
                    navigate("/order/orderUpload/review-order")
                }
            }
        }

        if(fileDetailsStatus === "success" && module === "BulkInspection") {
            prefetchAPICall("getBulkTicketDetails")
        }        

    },[fileDetails?.data])

    useEffect(()=>{
        if(Array.isArray(fileDetails) && fileDetails.length > 0 && fileDetails[0]?.status === "COMPLETED" && module === "productLifecycle") {
            prefetchAPICall("getProductLifecycleStatusList")
        }
    },[fileDetails])

    useEffect(()=>{
        if(orderManagementUpload && fileDetailsStatus === "success" && bindOrderUploadStatus === "success"){
            const bindData = fileDetails?.data?.map(fileRow => {
                let dataExist = bindOrderUpload?.data?.filter( orderRow => fileRow?.id === orderRow?.upload_id )
                if(dataExist?.length > 0)
                {
                    return { ...fileRow, order_status: dataExist[0]?.order_status , order_id: dataExist[0]?.order_id }
                }
                else{
                    return { ...fileRow , order_status: "" , order_id: "" } 
                }
            })
            setBindedOrderUploadList(bindData)
        }
    },[fileDetails?.data, bindOrderUpload?.data])

    const viewOptions = [
        {
            value: "10",
            label: t("pageOption.lastDays1")
        },
        {
            value: "30",
            label: t("pageOption.lastDays2")
        },
        {
            value: "60",
            label: t("pageOption.lastDays3")
        },
        {
            value: "90",
            label: t("pageOption.lastDays4")
        }
    ]
    const isDisabledUpload = (Object.keys(uploadPermissionDetails).length && 
    (!uploadPermissionDetails?._write && !uploadPermissionDetails?._update)) ? true : false

    const prefetchAPICall = (key) => {
        return queryClient.invalidateQueries({
            queryKey: [key]
        })
    }
    return (
        <>
            <Loader loading={ fileDetailsStatus === "pending" }/>
            <div className="flex flex-col items-start gap-[20px] self-stretch">
                <div className={ `${uploaderWrapperClass} flex justify-end items-end gap-4 w-full` }>
                    <div className={ `flex h-[80px] flex-col justify-center 
                        items-center gap-[8px] ${isOlderUpload ? "w-[100%]": "w-[80%]"}` }>
                        <FileUploderWithDragandDrop
                            fileData={ uploadedData }
                            onUpload={ onHandleUpload }
                            onDelete={ handleRemoveSaveData }
                            sendFileAsBinary={ sendFileAsBinary }
                            count={ count }
                            formats={ formats }
                            uploaderLabel={ uploaderLabel }
                            filesSupportLabel={ filesSupportLabel }
                            module = { module }
                            isCustomStyling = { isCustomStyling }
                            setIsUploadClicked = { setIsUploadClicked }
                            useNewApiforUpload = { useNewApiforUpload }
                            disabled={ (isDisabledUpload || disabled) ? true : false }
                            customFileName={ customFileName }
                            bulkTicketID = { bulkTicketID }
                            orderManagementUpload= { orderManagementUpload }
                            serviceCenterId = { module === "serviceCenterUpload" ? customerNumber :  serviceCenterId } 
                            customerNumber ={ customerNumber }
                        />
                    </div>
                    { orderManagementUpload && serviceCenterFeature && (
                        <div className="relative w-[25%]">
                            <ServiceCenterFilter defaultValue={ serviceCenterDefaultValue } 
                                serviceCenterListData = { serviceCenterListData } 
                                serviceCenterHandler={ serviceCenterHandler } 
                                disabled={ disabled }/>
                        </div>
                    ) }
                    { !isOlderUpload && (
                        <div className="flex w-[25%] flex-col items-start gap-[4px]">
                            <Dropdown
                                className={ "h-[45px] w-[100%] mt-0 mr-0" }
                                placeholder={ t("common.uploaderHistoryLabel") }
                                options={ viewOptions }
                                name="view"
                                id="view"
                                value={ viewselected }
                                isNotRequired={ true }
                                changeHandler={ onHandleViewChange }
                            />
                        </div>
                    ) }
                </div>
                { !isOlderUpload && (
                    <div className="flex flex-col justify-center gap-4 slef-stretch w-full">
                        { orderManagementUpload ? 
                            <ReactTable columns={ column } 
                                disableSearch={ true } 
                                iswithoutBorder={ true } 
                                data={ bindedOrderUploadList } 
                                title="" 
                                module="order_min_max"
                                disableHeader={ true } />
                            :
                            <ReactTable columns={ column } 
                                disableSearch={ true } 
                                iswithoutBorder={ true } 
                                data={ useNewApiforUpload ? fileDetails?.data || [] : fileDetails || [] } 
                                title="" 
                                module="order_min_max"
                                disableHeader={ true } />
                        }
                    </div>
                ) }
            </div>
        </>
    )
}


export default Uploader
